<template>
  <div class="title-bubble">
    <span class="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "TitleBubble",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@s/common.scss";

.title-bubble {
  background: url(../../../assets/ceping113/title_bubble_bg.png) 0 0 no-repeat;
  background-size: 4.587rem 1.44rem;
  height: 1.44rem;
  width: 4.587rem;
  position: absolute;
  left: 0;
  top: -0.48rem;
  padding-bottom: 0.48rem;
  text-align: center;

  .text {
    color: rgba(254, 254, 251, 1);
    font-size: 0.373rem;
    font-weight: bold;
    white-space: nowrap;
    line-height: 0.96rem;
  }
}
</style>